import {toLonLat} from 'ol/proj';
import {lineString} from '@turf/helpers';
import length from '@turf/length';

export const calculateLength = coordinates => {
    const lonLatCoordinates = coordinates.map(coordinate => toLonLat(coordinate));
    const line = lineString(lonLatCoordinates);

    return length(line).toFixed(0);
};
